import * as v from "valibot";
import { baseVals, defineRecordSchema, defineValidation, listVals } from "../../common/validation.common";
import { ComplaintStatusEnum, ProvisionItemStatusEnum, ProvisionSpecStatusEnum } from "../../data/enums";

export namespace CustomerComplaintValidation {
    export const Record = defineValidation(
        defineRecordSchema({
            filters: v.object({
                status: v.optional(v.array(v.picklist(ComplaintStatusEnum.values))),
            }),
        }),
    );

    export const Create = defineValidation(
        v.object({
            customerId: baseVals.string(),
            priority: baseVals.intRange(1, 10, "Prioritas"),
            name: baseVals.string(),
            notes: v.optional(baseVals.stringEmptiable()),
        }),
    );

    export const Update = defineValidation(
        v.object({
            priority: v.exactOptional(baseVals.intRange(1, 10, "Prioritas")),
            complaintData: v.exactOptional(
                v.object({
                    schedule: v.optional(baseVals.isoDate("Jadwal Perbaikan")),
                    supervisorId: v.optional(baseVals.string()),
                    technicianIds: v.optional(listVals.stringList("Pelaksana")),
                    ccIds: v.optional(listVals.stringListEmptiable()),
                    notes: v.optional(baseVals.stringEmptiable()),
                }),
            ),
            subscriptionId: v.exactOptional(baseVals.string()),
        }),
    );

    export const ComplaintCreate = defineValidation(
        v.object({
            schedule: baseVals.isoDate("Jadwal Perbaikan"),
            supervisorId: baseVals.string(),
            technicianIds: listVals.stringList("Pelaksana"),
            ccIds: v.optional(listVals.stringList("CC")),
        }),
    );

    export const ComplaintFinish = defineValidation(
        v.object({
            subscriptionId: baseVals.string(),
        }),
    );

    export const ProvisionCreate = defineValidation(
        v.object({
            warehouseId: baseVals.string(),
            specs: v.pipe(
                v.array(
                    v.object({
                        name: baseVals.string(),
                        status: v.picklist(ProvisionSpecStatusEnum.values),
                        quantity: baseVals.intMin(1, "Jumlah"),
                        notes: v.optional(baseVals.stringEmptiable()),
                    }),
                ),
                v.minLength(1, "Daftar Kebutuhan Barang tidak boleh kosong"),
            ),
        }),
    );

    export const ProvisionCancel = defineValidation(
        v.object({
            provisionId: baseVals.string(),
        }),
    );

    export const ComplaintReport = defineValidation(
        v.object({
            notes: v.optional(baseVals.stringEmptiable()),
            prevItemIds: listVals.stringListEmptiable(),
            newItemIds: listVals.stringListEmptiable(),
        }),
    );

    export const ProvisionFinalize = defineValidation(
        v.object({
            items: v.array(
                v.object({
                    id: baseVals.string(),
                    status: v.picklist(ProvisionItemStatusEnum.values),
                    price: v.optional(baseVals.intMin(0, "Harga")),
                }),
            ),
        }),
    );
}
